<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  #app.body-bg {
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    background-attachment: fixed;
    padding-top: 100px;
  }

  #app.body-bg .web-body {
    width: 1220px;
    margin: 0 auto;
    border-radius: 4px;
    background-color: #FFFFFF;
    overflow: hidden;
  }

  #app.body-bg .header-nav {
    background-color: #ffffff;
  }

  #app.body-bg .header-nav ul {
    /* background-color: #131313; */
    background-color: #E94230;
  }

  #app.body-bg .web-web-header .web-main {
    width: 100%;
  }

  /* 背景顶部跳转链接 */
  #app.body-bg .web-header .web-ad {
    display: block;
    width: 1220px;
    height: 100px;
    position: fixed;
    top: 0;
    cursor: pointer;
  }

  @media screen and (max-width: 800px) {
    #app.body-bg {
      background-image: none;
      padding-top: 0;
    }

    #app.body-bg .web-body {
      width: 100%;
    }

    #app.body-bg .web-header .web-ad {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue